// ============================================================
// drumNavigation - the action drum's cursor arithmetic
// ============================================================
// Where each plate sits relative to the cursor, where a step lands (over
// disabled plates, with wrap), where Home and End land, and how a wheel
// event's delta becomes pixels. Pure; ActionDrum holds the state.

/** `i` wrapped into [0, n). */
export function wrapIndex(i: number, n: number): number {
  return ((i % n) + n) % n;
}

/** Signed offset of plate `i` from the cursor, in (-n/2, n/2] - the armoury's circularOffset. */
export function circularOffset(i: number, cursor: number, n: number): number {
  let d = i - cursor;
  if (d > n / 2) d -= n;
  if (d < -n / 2) d += n;
  return d;
}

/**
 * Where a step of `delta` from `c` lands: the next chamberable plate in
 * that direction, looking at most one full revolution; `c` itself when
 * none is.
 */
export function stepCursor(c: number, delta: number, n: number, chamberable: (i: number) => boolean): number {
  let i = wrapIndex(c + delta, n);
  for (let guard = 0; guard < n && !chamberable(i); guard++) i = wrapIndex(i + delta, n);
  return chamberable(i) ? i : c;
}

/**
 * The first (Home) or last (End) chamberable plate, or undefined. Scanning
 * inward from the chosen end means End never lands mid-cylinder when the
 * last few plates happen to be dimmed.
 */
export function endIndex(end: 'Home' | 'End', n: number, chamberable: (i: number) => boolean): number | undefined {
  const order = Array.from({ length: n }, (_, i) => (end === 'Home' ? i : n - 1 - i));
  return order.find((i) => chamberable(i));
}

/** Pixels per unit of a WheelEvent's deltaMode: pixels, lines (~20px), pages (~120px). */
export function wheelScale(deltaMode: number): number {
  if (deltaMode === 1) return 20;
  return deltaMode === 2 ? 120 : 1;
}
